exports.BET_TYPE_NAME = {
  ssc: '时时彩',
  xyrb: 'PC蛋蛋',
  nn: '牛牛',
  PK10: 'PK10系列',
  lhc: '六合彩',
  ks: '快3',
  three: '低频彩',
  choose5: '11选5',
  hpten: '快乐十分'
};
// 0,时时彩;1 PK10,2 11选5,3 幸运28,4 快3, 5 六合彩,6 牛牛,7低频彩,8快乐10分
exports.BET_TYPE_LIST = {
  0: 'ssc',
  1: 'PK10',
  2: 'choose5',
  3: 'xyrb',
  4: 'ks',
  5: 'lhc',
  6: 'nn',
  7: 'three',
  8: 'hpten'
};

exports.LHC_BALL_BG_COLOR = ['01,02,07,08,12,13,18,19,23,24,29,30,34,35,40,45,46', '03,04,09,10,14,15,20,25,26,31,36,37,41,42,47,48', '05,06,11,16,17,21,22,27,28,32,33,38,39,43,44,49'];

exports.LHC_TYPE_LIST = [
  { type: 'sx', name: '生肖', list: ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'] },
  { type: 'wx', name: '五行', list: ['金', '木', '水', '火', '土'] }
  // { type: 'jq', name: '家禽野兽' },
  // { type: 'nannv', name: '男女生肖' },
  // { type: 'td', name: '四季生肖' },
  // { type: 'qqsh', name: '琴棋书画' },
  // { type: 'sanse', name: '三色生肖' }
];

exports.LHC_TYPE_NAME = {
  sx: ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'],
  wx: ['金', '木', '水', '火', '土'],
  jq: ['家禽', '野兽'],
  nannv: ['男肖', '女肖'],
  td: ['天肖', '地肖'],
  sj: ['春肖', '夏肖', '秋肖', '东肖'],
  qqsh: ['琴肖', '棋肖', '书肖', '画肖'],
  sanse: ['红肖', '蓝肖', '绿肖']
};



// WEBPACK FOOTER //
// ./src/helpers/BETTYPEDATA.js